import { AppointmentInfo, ServiceAppointmentInfo } from '../sdk/sdk';

export interface AppointmentHistoryItem {
  id: string;
  opportunityId: string;
  startDate?: Date;
  appointmentTypeId?: string;
  appointmentTypeName?: string;
  assigneeName?: string;
  dispositionId?: string;
  dispositionName?: string;
  subDispositionId?: string;
  subDispositionName?: string;
  isServiceRun: boolean;
  leadTypeId?: string;
  geoZoneId?: string;
  branchId?: string;
}

export function mapSalesAppointment(a: AppointmentInfo): AppointmentHistoryItem {
  return {
    id: a.id ?? '',
    opportunityId: a.opportunityId ?? '',
    startDate: a.startDate,
    appointmentTypeId: a.appointmentTypeId,
    appointmentTypeName: a.appointmentTypeName,
    assigneeName: a.inspectorName,
    dispositionId: a.dispositionId,
    dispositionName: a.dispositionName,
    subDispositionId: a.subDispositionId,
    subDispositionName: a.subDispositionName,
    isServiceRun: false,
    leadTypeId: a.leadTypeId,
    geoZoneId: a.geoZoneId,
    branchId: a.branchId,
  };
}

export function mapServiceAppointment(sa: ServiceAppointmentInfo): AppointmentHistoryItem {
  return {
    id: sa.id ?? '',
    opportunityId: sa.opportunityId ?? '',
    startDate: sa.startDate,
    appointmentTypeName: sa.leadTypeName || 'Service',
    assigneeName: sa.serviceTechName,
    dispositionId: sa.dispositionId,
    dispositionName: sa.dispositionName,
    isServiceRun: true,
    leadTypeId: sa.leadTypeId,
    branchId: sa.branchId,
  };
}

export function mergeAndSortAppointments(
  sales: AppointmentInfo[],
  service: ServiceAppointmentInfo[],
): AppointmentHistoryItem[] {
  const mapped = [
    ...sales.map(mapSalesAppointment),
    ...service.map(mapServiceAppointment),
  ];
  return mapped.sort((a, b) => (b.startDate?.getTime() ?? 0) - (a.startDate?.getTime() ?? 0));
}
